import WarningTwoTone from '@ant-design/icons/WarningTwoTone'
import { Button, Divider, Popover, Typography } from 'antd'
import React from 'react'
import styled from 'styled-components'
import { GeckoTheme } from 'styles/GeckoTheme'

const { Text } = Typography

const DeleteConfirmMessageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const DeleteConfirmButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  gap: 0.5rem;
`
const DeleteConfirmContent: React.FC<{
  confirm: () => void
  cancel: () => void
}> = (props) => {
  return (
    <div>
      <DeleteConfirmMessageContainer>
        <WarningTwoTone
          style={{ fontSize: '64px' }}
          twoToneColor={GeckoTheme.colors.BrightOrange}
        />
        <Text>Are you sure you want to delete this?</Text>
      </DeleteConfirmMessageContainer>
      <Divider plain></Divider>
      <DeleteConfirmButtonContainer>
        <Button onClick={props.confirm}>Confirm</Button>
        <Button onClick={props.cancel} type='primary'>
          Cancel
        </Button>
      </DeleteConfirmButtonContainer>
    </div>
  )
}

export interface DeleteConfirmPopoverProps {
  open: boolean
  confirm: () => void
  cancel: () => void
  children: React.ReactNode
}

export const DeleteConfirmPopover: React.FC<DeleteConfirmPopoverProps> = (
  props
) => {
  return (
    <Popover
      title={'Confirm'}
      placement='top'
      content={
        <DeleteConfirmContent confirm={props.confirm} cancel={props.cancel} />
      }
      open={props.open}>
      {props.children}
    </Popover>
  )
}
